export const DEFAULT_COMPOSITION_ID = 'ArticleTemplateV1';
export const RSS_VIDEO_GENERATION_CONFIG_KEY = 'rssVideoGenerationConfig';
export const PAGE_LEVEL_CONTENT_VIDEOS_KEY = 'pageLevelContentVideos.enabled';
export const SECTION_PAGE_LEVEL_CONTENT_VIDEOS_DISABLE_KEY = 'featuresData.pageLevelContentVideos.disable';

export const COMPOSITION_ID_OPTIONS = [
	{ label: DEFAULT_COMPOSITION_ID, value: DEFAULT_COMPOSITION_ID }
];

export const LANGUAGE_OPTIONS = [
	{ label: 'English', value: 'en' },
	{ label: 'Japanese', value: 'ja' }
];

export const getLanguageLabel = (language) => {
	return LANGUAGE_OPTIONS.find((option) => option.value === language)?.label || language;
};

export const createInitialJobForm = () => ({
	pageURL: '',
	language: 'en',
	compositionId: DEFAULT_COMPOSITION_ID,
	debug: false
});

export const INITIAL_FEED_FORM = {
	feedUrl: '',
	dailyLimit: 10,
	pollIntervalMinutes: 120,
	compositionId: DEFAULT_COMPOSITION_ID,
	language: 'en',
	active: false
};

export const JOB_STAGES = {
	QUEUED: 'queued',
	FETCHING_ARTICLE: 'fetching_article',
	GENERATING_TEMPLATE_JSON: 'generating_template_json',
	RENDERING_VIDEO_START: 'rendering_video',
	UPLOADING: 'uploading',
	TRANSCODING: 'transcoding',
	POLLING: 'polling',
	CREATING_PLAYLIST: 'creating_playlist',
	SYNCING_PLAYLIST: 'syncing_playlist',
	COMPLETED: 'completed',
	FAILED: 'failed',
	CANCELLING: 'cancelling',
	CANCELLED: 'cancelled'
};

export const EDITABLE_STAGE_FLOW = [
	JOB_STAGES.QUEUED,
	JOB_STAGES.FETCHING_ARTICLE,
	JOB_STAGES.GENERATING_TEMPLATE_JSON,
	JOB_STAGES.RENDERING_VIDEO_START,
	JOB_STAGES.UPLOADING,
	JOB_STAGES.TRANSCODING,
	JOB_STAGES.POLLING,
	JOB_STAGES.CREATING_PLAYLIST,
	JOB_STAGES.SYNCING_PLAYLIST,
	JOB_STAGES.COMPLETED
];

export const JOB_STAGE_FILTERS = {
	ALL: 'all',
	QUEUED: 'queued',
	PROCESSING: 'processing',
	COMPLETED: 'completed',
	FAILED: 'failed',
	CANCELLED: 'cancelled'
};

export const JOB_STAGE_FILTER_OPTIONS = [
	{ label: 'All stages', value: JOB_STAGE_FILTERS.ALL },
	{ label: 'Queued', value: JOB_STAGE_FILTERS.QUEUED },
	{ label: 'Processing', value: JOB_STAGE_FILTERS.PROCESSING },
	{ label: 'Completed', value: JOB_STAGE_FILTERS.COMPLETED },
	{ label: 'Failed', value: JOB_STAGE_FILTERS.FAILED },
	{ label: 'Cancelled', value: JOB_STAGE_FILTERS.CANCELLED }
];

export const JOB_TABLE_HEADER = [
	{ id: 'jobId', label: 'Job ID' },
	{ id: 'stage', label: 'Stage' },
	{ id: 'createdAt', label: 'Queued At', sortable: true },
	{ id: 'lastExecutedAt', label: 'Last Executed At', sortable: true },
	{ id: 'progress', label: 'Progress', sortable: true },
	{ id: 'pageURL', label: 'Page URL', sx: { width: 220, maxWidth: 220 } },
	{ id: 'actions', label: 'Actions' }
];

export const MODAL_BORDER = 'rgba(15, 23, 42, 0.1)';
export const MODAL_BORDER_DARK = 'rgba(255, 255, 255, 0.12)';
export const BRAND_RED = '#FC4B58';
export const STATUS_COLORS = {
	completed: '#10b981',
	failed: '#ef4444',
	cancelled: '#f59e0b',
	cancelling: '#7c3aed',
	processing: '#f59e0b'
};
